{
  "name": "@vladmandic/face-api",
  "version": "1.7.9",
  "description": "FaceAPI: AI-powered Face Detection & Rotation Tracking, Face Description & Recognition, Age & Gender & Emotion Prediction for Browser and NodeJS using TensorFlow/JS",
  "sideEffects": false,
  "main": "dist/face-api.node.js",
  "module": "dist/face-api.esm.js",
  "browser": "dist/face-api.esm.js",
  "types": "types/face-api.d.ts",
  "author": "Vladimir Mandic <mandic00@live.com>",
  "bugs": {
    "url": "https://github.com/vladmandic/face-api/issues"
  },
  "homepage": "https://vladmandic.github.io/face-api/demo/webcam.html",
  "license": "MIT",
  "engines": {
    "node": ">=14.0.0"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/vladmandic/face-api.git"
  },
  "scripts": {
    "start": "node --no-warnings demo/node.js",
    "dev": "build --profile development",
    "build": "node build.js",
    "lint": "eslint src/ demo/",
    "test": "node --trace-warnings test/test-node.js",
    "scan": "npx auditjs@latest ossi --dev --quiet"
  },
  "keywords": [
    "face-api",
    "faceapi",
    "face-detection",
    "age-gender",
    "emotion-detection",
    "face-recognition",
    "face",
    "face-description",
    "tensorflow",
    "tensorflowjs",
    "tfjs"
  ],
  "devDependencies": {
    "@canvas/image": "^1.0.1",
    "@microsoft/api-extractor": "^7.34.0",
    "@tensorflow/tfjs": "^4.2.0",
    "@tensorflow/tfjs-backend-cpu": "^4.2.0",
    "@tensorflow/tfjs-backend-wasm": "^4.2.0",
    "@tensorflow/tfjs-backend-webgl": "^4.2.0",
    "@tensorflow/tfjs-backend-webgpu": "0.0.1-alpha.17",
    "@tensorflow/tfjs-converter": "^4.2.0",
    "@tensorflow/tfjs-core": "^4.2.0",
    "@tensorflow/tfjs-data": "^4.2.0",
    "@tensorflow/tfjs-layers": "^4.2.0",
    "@tensorflow/tfjs-node": "^4.2.0",
    "@tensorflow/tfjs-node-gpu": "^4.2.0",
    "@types/node": "^18.11.18",
    "@types/offscreencanvas": "^2019.7.0",
    "@typescript-eslint/eslint-plugin": "^5.49.0",
    "@typescript-eslint/parser": "^5.49.0",
    "@vladmandic/build": "^0.7.15",
    "@vladmandic/pilogger": "^0.4.7",
    "esbuild": "^0.17.5",
    "eslint": "^8.33.0",
    "eslint-config-airbnb-base": "^15.0.0",
    "eslint-plugin-import": "^2.27.5",
    "eslint-plugin-json": "^3.1.0",
    "eslint-plugin-node": "^11.1.0",
    "eslint-plugin-promise": "^6.1.1",
    "rimraf": "^4.1.2",
    "seedrandom": "^3.0.5",
    "tslib": "^2.5.0",
    "typedoc": "^0.23.24",
    "typescript": "4.9.4"
  }
}
